/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Hltbtitle2Inputs */

const id_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa Lama untuk Menamatkan`)
};

const ms_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa Lama untuk Menamatkan`)
};

const da_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const de_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange braucht man?`)
};

const en_us2_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const es_es2_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuánto tiempo para completar`)
};

const es_mx2_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué tanto dura`)
};

const fil_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaano Katagal Laruin`)
};

const fr_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps pour battre`)
};

const it_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo per completare`)
};

const hu_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mennyi ideig tart kiverni`)
};

const nl_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang te spelen`)
};

const no_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor lang tid å slå`)
};

const pl_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak długo ukończyć`)
};

const pt_br2_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo para zerar`)
};

const pt_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo para completar`)
};

const ro_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cât timp de finalizare`)
};

const fi_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuinka kauan läpäistä`)
};

const sv_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const vi_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const tr_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const cs_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const bg_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

const ru_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сколько времени нужно на прохождение`)
};

const uk_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час проходження`)
};

const ar_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كم من الوقت للإنهاء`)
};

const hi_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा करने में कितना समय`)
};

const th_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระยะเวลาในการเล่นจบ`)
};

const ja_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリアまでの時間`)
};

const zh_cn2_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通关时间 (How Long To Beat)`)
};

const zh_hant1_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通關時間 (How Long To Beat)`)
};

const ko_offerdetail_overview_hltbtitle2 = /** @type {(inputs: Offerdetail_Overview_Hltbtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Long To Beat`)
};

/**
* | output |
* | --- |
* | "How Long To Beat" |
*
* @param {Offerdetail_Overview_Hltbtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_hltbtitle2 = /** @type {((inputs?: Offerdetail_Overview_Hltbtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Hltbtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "da") return da_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "de") return de_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "it") return it_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "no") return no_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "th") return th_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_hltbtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_hltbtitle2(inputs)
	return ko_offerdetail_overview_hltbtitle2(inputs)
});
export { offerdetail_overview_hltbtitle2 as "offerDetail.overview.hltbTitle" }